// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DuplicateProposalMutationVariables = Types.Exact<{
  duplicateProposalId: Types.Scalars['ID']['input'];
}>;


export type DuplicateProposalMutation = { __typename?: 'Mutation', duplicateProposal: { __typename: 'Proposal', id: string } };

export const Operations = {
  Mutation: {
    DuplicateProposal: 'DuplicateProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DuplicateProposalDocument = gql`
    mutation DuplicateProposal($duplicateProposalId: ID!) {
  duplicateProposal(id: $duplicateProposalId) {
    __typename
    id
  }
}
    `;
export type DuplicateProposalMutationFn = Apollo.MutationFunction<DuplicateProposalMutation, DuplicateProposalMutationVariables>;

/**
 * __useDuplicateProposalMutation__
 *
 * To run a mutation, you first call `useDuplicateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProposalMutation, { data, loading, error }] = useDuplicateProposalMutation({
 *   variables: {
 *      duplicateProposalId: // value for 'duplicateProposalId'
 *   },
 * });
 */
export function useDuplicateProposalMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProposalMutation, DuplicateProposalMutationVariables>(DuplicateProposalDocument, options);
      }
export type DuplicateProposalMutationHookResult = ReturnType<typeof useDuplicateProposalMutation>;
export type DuplicateProposalMutationResult = Apollo.MutationResult<DuplicateProposalMutation>;
export type DuplicateProposalMutationOptions = Apollo.BaseMutationOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>;